import React from 'react';
import { useStateContext } from '../../../context/ContextProvider';
import ColorLandingPage from '../../LandingPages/ColorLandingPage';
import { neonMap, textMap } from '../../../components/ColorMappingOptions';

function RichMindOystra({
    language
}) {
    const color = "orange";

    const images = [
        "/assets/images/projects/richmind-oystra/1.webp",
        "/assets/images/projects/richmind-oystra/2.webp",
        "/assets/images/projects/richmind-oystra/3.webp",
        "/assets/images/projects/richmind-oystra/4.webp",
    ];

    const poster = "/assets/images/projects/richmind-oystra/poster.jpg";
    const video = "/assets/images/projects/richmind-oystra/richmind-oystra.mp4";

    const {
        langs,
        langCode,
        userInfo,
        RICHMIND_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className={`font-bold text-center text-xl text-white neon-white`}>
                        منزلك المثالي بانتظارك
                        <br />
                        <span className={color == "gold" ? "primary-text neon-gold" : `${textMap[color]} ${neonMap[color]}`}>سارع باغتنام الفرصة!!</span>
                    </h1>

                ) : (
                    <h1 className="font-bold text-center text-xl lg:text-2xl 2xl:text-3xl capitalize text-white neon-white">
                        Your dream home is waiting
                        <br />
                        <span className={color == "gold" ? "primary-text neon-gold" : `${textMap[color]} ${neonMap[color]}`}>act fast!!</span>
                    </h1>
                )}
            </>
        );
    }

    const gridDetails = [
        {
            topic: language == "ar" ? "أنواع الوحدات" : "Unit Types",
            text: language == "ar" ? "دوبلكس وغرف من 1 إلى 4 وبنتهاوس" : "1 to 4 Bedroom duplexes & penthouses",
        },
        {
            topic: language == "ar" ? "الأسعار تبدأ من" : "Starting Price",
            text: language == "ar" ? "2.8 مليون درهم" : "AED 2.8M",
        },
        {
            topic: language == "ar" ? "خطة الدفع" : "Payment Plan",
            text: language == "ar" ? "70/30" : "70/30",
        },
        // {
        //     topic: language == "ar" ? "تسليم المشروع" : "Handover",
        //     text: language == "ar" ? "الربع الثاني من 2029" : "Q2 2029",
        // },
    ];

    const imageDetails = {
        danger: true,
        title: language == "ar" ? "التناغم المثالي <span class='text-white neon-white'>بين العمارة والتصميم والطبيعة!!</span>" : "The perfect harmony <span class='text-white neon-white'>of architecture, design, and nature!!</span>",
        desc: language == "ar" ? "عنوان ساحلي مُصمم بعناية واهتمام بالتفاصيل وبنظرة فريدة. صممه مكتب زها حديد للعمارة، يجمع Oystra أسماء عالمية مرموقة لتقديم تجربة استثنائية على شواطئ المرجان." : "A coastal address shaped by design, detail, and a distinct point of view. Designed by Zaha Hadid Architects, Oystra brings together world-renowned names to create something exceptional on the shores of Al Marjan."
    };

    const amenityDetails = [
        {
            icon: "/assets/images/icons/gym.svg",
            en_text: "Personal Training Studios",
            ar_text: "استوديوهات تدريب شخصية",
        },
        {
            icon: "/assets/images/icons/pool.svg",
            en_text: "Crystal Lagoon with Beach Access",
            ar_text: "بحيرة كريستالية مع الوصول إلى الشاطئ",
        },
        {
            icon: "/assets/images/icons/parking.svg",
            en_text: "Covered Parking with Security",
            ar_text: "مواقف سيارات مغطاة مع أمن وحراسة",
        },
        {
            icon: "/assets/images/icons/greenary.svg",
            en_text: "Golf Simulator & putting greens",
            ar_text: "محاكاة جولف ومناطق وضع الكرة",
        },
        {
            icon: "/assets/images/icons/restaurant.svg",
            en_text: "Curated coffee blends at café",
            ar_text: "خليط القهوة المختارة في المقهى",
        }
    ];

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/venice",
                        ar: "/projects/azizi/venice/ar",
                        fa: "/projects/azizi/venice/fa",
                        tr: "/projects/azizi/venice/tr",
                    }}
                /> */}
            <ColorLandingPage
                color={color}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                gridDetails={gridDetails}
                amenityDetails={amenityDetails}
                imageDetails={imageDetails}
                projectName={"Oystra"}
                base_url={RICHMIND_URL}
                developer="Richmind"
                project="Oystra"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                enquiries={["1 Bedroom", "2 Bedrooms", "3 Bedrooms", "4 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                // otpCode={6}
                otpCode={101}
            />
        </>
    );
}

export default RichMindOystra;
